import React from 'react';

const bannerData = [
  {
    id: 1,
    title: '周末家庭聚餐',
    description: '精选家常菜谱，让亲情在餐桌上升温',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&q=80'
  },
  {
    id: 2,
    title: '精致西式料理',
    description: '在家也能做出米其林级别的美味',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80'
  }
];

const Banner = () => {
  return (
    <section className="banner-section">
      <div className="banner-grid">
        {bannerData.map((banner) => (
          <div className="banner-item" key={banner.id}>
            <img src={banner.image} alt={banner.title} />
            <div className="banner-overlay">
              <h3>{banner.title}</h3>
              <p>{banner.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Banner;
